

































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
  getCurrentInstance,
  ComponentInternalInstance,
  onMounted,
} from '@vue/composition-api';
import { CloseCircleFilledIcon, SearchIcon } from 'tdesign-icons-vue';

// 引入组件
import searchHistory from '@/renderer/components/searchInput/searchHistory.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import { historyHandler } from '@/renderer/components/searchInput/compositions/historySearchHandler';

// 引入工具类
import { GetDropdownItemShortCutText } from '@/renderer/scripts/utils/hotkeyDataHelper';
export default defineComponent({
  model: {
    prop: 'keyword',
    event: 'change',
  },
  components: {
    CloseCircleFilledIcon,
    SearchIcon,
    searchHistory,
  },
  props: {
    keyword: String,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const isGlobalSearch = computed(() => vm.$route.name === 'workbench');
    const show = reactive({
      history: false,
      scope: false,
      popup: false, // popup 显示
    });

    const placeholder = ref(
      i18n_t('搜索 {slot1}', {
        slot1: GetDropdownItemShortCutText('search'),
      }),
    );
    const inputBox = ref();
    const isInFolder = computed(() => (vm.$route.query?.path ? vm.$route.query.path : ''));
    const showSearchClear = ref(true);
    /**
     * T-design 等宽不能根据窗口大小变化而变化
     * inputWidth 添加该字段进行等宽处理, 300兜底处理
     */
    const inputWidth = ref(300);
    const searchKeyword = computed<string>({
      get() {
        return props.keyword as string;
      },
      set(val) {
        context.emit('change', val);
      },
    });
    const { historyStore, methods: historyMethods } = historyHandler();
    const methods = {
      /**
       * 选择搜索范围
       */
      onSelectScope(e: Event) {
        let el = e.target as HTMLElement;
        if (el.dataset && !el.dataset.scope) {
          el = el.parentNode as HTMLElement;
        }
        const { scope } = el.dataset;
        if (el.nodeName.toLowerCase() === 'li' && scope) {
          show.popup = false;
          searchKeyword.value && historyMethods.setHistory(searchKeyword.value);
          context.emit('search', scope);
        }
      },
      handleSearch() {
        searchKeyword.value && historyMethods.setHistory(searchKeyword.value);
        const spaceScope = isInFolder.value ? 'current' : 'all';
        const scope = vm.$route.name === 'workbench' ? 'global' : spaceScope;
        context.emit('search', scope);
      },
      handleClearInput() {
        searchKeyword.value = '';
        show.scope = false;
        show.history = true;
      },
      openHistory() {
        show.history = true;
        show.scope = false;
        show.popup = true;
      },
      openSelect() {
        show.history = false;
        show.scope = true;
        show.popup = true;
      },
      onChange(val: string) {
        context.emit('change', val);
        placeholder.value = i18n_t('请输入你需要搜索的内容');
        if (val) {
          methods.openSelect();
        } else {
          methods.openHistory();
        }
      },
      onBlur() {
        context.emit('blur');
        placeholder.value = i18n_t('搜索 {slot1}', {
          slot1: GetDropdownItemShortCutText('search'),
        });
      },
      onClickOutside(e: any) {
        show.popup = false;
        // 关闭时需要异步，否则会有白块
        setTimeout(() => {
          show.history = false;
          show.scope = false;
        }, 200);
      },
      isShowSearchClear() {
        inputWidth.value = inputBox.value.$el.offsetWidth;
        if (inputWidth.value < 100) {
          showSearchClear.value = false;
        } else {
          showSearchClear.value = true;
        }
      },
    };
    onMounted(() => {
      methods.isShowSearchClear();
    });
    watch(
      () => show.history,
      val => {
        val && historyMethods.getHistory();
      },
    );
    window.onresize = (e: Event) => {
      methods.isShowSearchClear();
    };
    return {
      isGlobalSearch,
      isInFolder,
      historyStore,
      historyMethods,
      placeholder,
      show,
      inputBox,
      showSearchClear,
      inputWidth,
      searchKeyword,
      ...methods,
    };
  },
});
